import { render } from "./MissedTrainingReasonView.vue?vue&type=template&id=d34c1a04"
import script from "./MissedTrainingReasonView.vue?vue&type=script&lang=js"
export * from "./MissedTrainingReasonView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__